import type SessionService from '@efdigital/ll-addon-auth/services/session';
import {
  CANCELLED_KEYS,
  HISTORY_KEYS,
} from '@efdigital/ll-addon-coaching/utils/coaching-sessions/session-status';
import {
  type CoachingSession,
  type CoachProfile,
} from '@efdigital/ll-addon-data';
import { queryCoachProfilesByUserIds } from '@efdigital/ll-xceed-v2/data/builders/coaching/coach-profiles';
import { queryCoachingSessionsByCoachingPlan } from '@efdigital/ll-xceed-v2/data/builders/coaching/coaching-sessions';
import type CoacheeService from '@efdigital/ll-xceed-v2/services/coachee';
import Route from '@ember/routing/route';
import { service } from '@ember/service';
import type { Store } from '@warp-drive/core';

import type { CoachingCoacheeCohortModel } from '../../cohort';

export type CoachingCoacheeCohortSessionsHistoryModel =
  CoachingCoacheeCohortModel & {
    history: CoachingSession[];
    cancelled: CoachingSession[];
    coaches: CoachProfile[];
  };

export default class CoachingCoacheeCohortSessionsHistoryRoute extends Route<CoachingCoacheeCohortSessionsHistoryModel> {
  @service declare coachee: CoacheeService;
  @service declare store: Store;
  @service declare session: SessionService;

  async model(): Promise<CoachingCoacheeCohortSessionsHistoryModel> {
    const cohortModel = this.modelFor(
      'coaching.coachee.cohort'
    ) as CoachingCoacheeCohortModel;

    const queryHistory = queryCoachingSessionsByCoachingPlan(
      cohortModel.coachingPlan!.id!,
      HISTORY_KEYS
    );
    const history = (await this.store.request(queryHistory)).content.data;

    const queryCancelled = queryCoachingSessionsByCoachingPlan(
      cohortModel.coachingPlan!.id!,
      CANCELLED_KEYS
    );
    const cancelled = (await this.store.request(queryCancelled)).content.data;

    const coachUserIds = Array.from(
      new Set(history.map((session) => session.coachUserId))
    );
    const queryCoaches = queryCoachProfilesByUserIds(coachUserIds);
    const coaches = await this.store.request(queryCoaches);

    return {
      ...cohortModel,
      history,
      cancelled,
      coaches: coaches.content.data,
    };
  }
}
